<p class="debugMessage"><small>account-invite:</small></p>
<div class="content local-content">
	<div class="invite_wrapper">
		<div class="inviteHeading">
			<span>My Invitations</span>
		</div>
		<div *ngIf="myInvites.length ==0" class="invitation">
			You have no new Invitations
		</div>
		<ng-container [ngTemplateOutlet]="invitation" *ngFor="let invite of myInvites"
			[ngTemplateOutletContext]="{ invite: invite, showMenu:false }"></ng-container>

		<div class="inviteHeading">
			<span style="margin-right: 1em;">History</span>
			<mat-slide-toggle [(ngModel)]="showAllInvitations" color="primary" (ngModelChange)="filterInvites(showAllInvitations)">
				Show Canceled</mat-slide-toggle>
		</div>
		<div *ngIf="oldInvites.length ==0" class="invitation">
			You have No Invitation History
		</div>
		<ng-container [ngTemplateOutlet]="invitation" *ngFor="let invite of oldInvites"
			[ngTemplateOutletContext]="{ invite: invite, showMenu:true }"></ng-container>
	</div>
</div>

<ng-template #invitation let-invite="invite" let-showMenu="showMenu">
	<div class="invitation" [ngStyle]="{'background-color': invite.Canceled === true ? 'salmon' :
									(invite.Accepted === true ? 'lightgreen' : '')}">
		<div class="body">
			<span class="accountName">{{invite.AccountName}}</span>
			<span class="inviteDetail">
				<span title="{{invite.Email}}">{{invite.Name}}</span>
				<span>&nbsp;Invited&nbsp;</span>
				<span>{{invite.InviteEmail}}</span>
				<span *ngIf="invite.InviteAsAdmin" >&nbsp;(As Admin) </span>
			</span>
		</div>
		<div class="menu" *ngIf="!invite.Canceled && !invite.Accepted && showMenu">
			<mat-icon [matMenuTriggerFor]="userAccountMenu">more_horiz</mat-icon>
		</div>
		<div class="buttons" *ngIf="!showMenu">
			<mat-chip-set>
				<mat-chip (click)="acceptInvite(invite.InviteGUID)">Accept</mat-chip>
				<mat-chip (click)="cancelInvite(invite.InviteGUID)">Reject</mat-chip>
			</mat-chip-set>
		</div>
		<mat-menu #userAccountMenu [overlapTrigger]="false" yPosition="below">
			<button mat-menu-item (click)="acceptInvite(invite.InviteGUID)" [disabled]="invite.InviteEmail != thisUser.Email">
				<mat-icon>check_circle</mat-icon><span>Accept</span>
			</button>
			<button mat-menu-item (click)="cancelInvite(invite.InviteGUID)" [disabled]="invite.Accepted">
				<mat-icon>unsubscribe</mat-icon><span>Cancel</span>
			</button>
			<button mat-menu-item (click)="resendInvite(invite.InviteGUID)" [disabled]="invite.Accepted || invite.InviteEmail == thisUser.Email">
				<mat-icon>outgoing_mail</mat-icon><span>Re-Send</span>
			</button>
		</mat-menu>
	</div>
</ng-template>
